import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=5fedd73c&scoped=true"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fedd73c",
  null
  
)

export default component.exports